import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FC, ReactNode } from 'react';

const useStyles = makeStyles((theme: any) => ({
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
    minWidth: 0,
  },
  label: {
    color: theme.palette.primary.light,
  },
  value: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: 0,
    color: theme.palette.primary.darker,
    fontVariantNumeric: 'tabular-nums',
  },
}));

type LabeledValueProps = Readonly<{
  label: string;
  children: ReactNode;
}>;

export const LabeledValue: FC<LabeledValueProps> = ({ label, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.field}>
      <Typography variant="caption" className={classes.label}>
        {label}
      </Typography>
      <div className={classes.value}>{children}</div>
    </div>
  );
};
